/**
 * /dashboard/performance/one-on-ones/new — Schedule a 1:1 (Phase 7.3a).
 *
 * Posts to POST /performance/1-1s. The manager defaults to the caller
 * (manager_id is HR-only).
 *
 * Migration note (Phase 3f — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/performance/one-on-ones/new/page.tsx.
 * Swaps:
 *   - "use client" dropped
 *   - next/link Link → @tanstack/react-router Link
 */

import { createFileRoute } from "@tanstack/react-router";
import { PerformanceModuleShell } from "@/components/shared/performance-module-shell";
import { PerformanceFeatureGate } from "@/components/performance/performance-feature-gate";
import { OneOnOneForm } from "@/components/performance/one-on-one-form";
import { Card, CardContent } from "@/components/ui/card";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/performance/one-on-ones/new",
)({
  component: NewOneOnOneRoute,
});

function NewOneOnOneRoute() {
  // Top-of-page Back button removed per Audit 4 Quick-Win #4 — the
  // bottom Cancel handles it.
  return (
    <PerformanceModuleShell
      title="Schedule a 1:1"
      description="Set up a check-in with a report (or, as their manager, a manager)."
    >
      <PerformanceFeatureGate>
        <Card>
          <CardContent className="py-6">
            <OneOnOneForm />
          </CardContent>
        </Card>
      </PerformanceFeatureGate>
    </PerformanceModuleShell>
  );
}
